import { VOUCHER as LABELS } from './labels.js';

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    indexLabel: LABELS.serialNumber,
    indexFixed: false,
    searchShow: false,
    searchBtn: true,
    columnBtn: false,
    align: 'center',
    menu: false,
    border: true,
    refreshBtn: false,
    highlightCurrentRow: true,
    selection: true,
    stripe: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    index: true,
    sortable: true,
    tip: false,
    indeterminate: true,
    searchSpan: 12,
    searchMenuSpan: 12,
    column: [
      { label: LABELS.receiptVoucherNumber, prop: 'deliveryNumber', search: true },
      { label: LABELS.voucherLineNumber, prop: 'deliveryItemNumber' },
      { label: LABELS.numberOfVouchers, prop: 'voucherQuantity' },
      { label: LABELS.orderNumber, prop: 'orderNumber', search: true },
      { label: LABELS.orderLineNumber, prop: 'orderItemNumber' },
      { label: LABELS.orderQuantity, prop: 'quantity' }
    ]
  }
};
